import { render, staticRenderFns } from "./paymentHeader.vue?vue&type=template&id=76a6ee00&"
import script from "./paymentHeader.vue?vue&type=script&lang=js&"
export * from "./paymentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports